import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import {
  Col,
  Container,
  Row,
  Form,
  Spinner,
  Button,
  Accordion,
} from "react-bootstrap";
import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import { EarningCard } from "./EarningCard";
// import { TopCountries } from "./TopCountries";
import { TableSales } from "./TableSales";
import styles from "./style/EarningPage.module.css";
import { useSelector, useDispatch } from "react-redux";
import { getAllEarningAction } from "@redux/actions";
import { useFormik } from "formik";
import * as Yup from "yup";
// import moment from "moment";
import { SelectField } from "@components/Input/SelectField";
import { InputField } from "@components/Input/InputField";
import { Paginator } from "@components/Paginator/Paginator";

const pageSizeList = [
  { id: 5, name: "5" },
  { id: 10, name: "10" },
  { id: 20, name: "20" },
];
const orderByList = [
  { id: "asc", name: "ASC" },
  { id: "desc", name: "DESC" },
];

const validateSchema = Yup.object().shape({
  startDay: Yup.date(),
  endDate: Yup.date(),
  Orderby: Yup.string(),
  PageSize: Yup.number(),
});

const initialValues = {
  startDay: "",
  endDate: "",
  Orderby: "desc",
  PageSize: "",
};

const EarningPage = () => {
  const { profile } = useSelector((state) => state.user);
  const { allEarning } = useSelector((state) => state.balance);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const callSubmit = () => {
    let data = {};
    if (values.Orderby) {
      data = {
        ...data,
        ...{
          Orderby: `createdAt ${values.Orderby}`,
        },
      };
    }
    if (Number(searchParams.get("PageNumber"))) {
      data = {
        ...data,
        ...{
          PageNumber: Number(searchParams.get("PageNumber")),
        },
      };
    }
    if (values.PageSize) {
      data = {
        ...data,
        ...{
          PageSize: values.PageSize,
        },
      };
    }
    if (values.startDay) {
      data = { ...data, ...{ startDay: values.startDay } };
    }
    if (values.endDate) {
      data = { ...data, ...{ endDate: values.endDate } };
    }

    dispatch(getAllEarningAction(data));
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    // setFieldError,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: () => {
      searchParams.set("PageNumber", 1);
      setSearchParams(searchParams, { replace: true });
      callSubmit();
    },
  });

  // useLayoutEffect(() => {
  //   searchParams.set("Orderby", "createdAt%20desc");
  //   searchParams.sort();
  //   setSearchParams(searchParams, { replace: true });
  // }, []);

  // useEffect(() => {
  //   dispatch(getAllEarningAction());
  // }, []);

  useEffect(() => {
    callSubmit();
  }, [dispatch, searchParams]);

  return (
    <Container className="p-5">
      <h5 className="mb-5">
        <i className="bi bi-currency-dollar"></i> Earning
      </h5>
      <Row className="g-4">
        <Col md={12}>
          <EarningCard content="Your balance:" money={profile.data.balance} />
        </Col>
        {/* <Col md={12} lg={4} className="mt-5">
          <TopCountries />
        </Col> */}
        <Col md={12} lg={12} className="mt-5">
          <Accordion className={styles.newDiscountContainer}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filter</Accordion.Header>
              <Accordion.Body>
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  className={styles.formContainer}
                >
                  <Row className="g-4">
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="startDay">
                        <Form.Label>Start Date*</Form.Label>
                        <InputField
                          name={"startDay"}
                          type={"datetime-local"}
                          // placeholder="Select start date"
                          placeholder="dd-mm-yyyy"
                          value={values.startDay}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          touchedValue={touched.startDay}
                          errorsValue={errors.startDay}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="endDate">
                        <Form.Label>End Date*</Form.Label>
                        <InputField
                          name={"endDate"}
                          type={"datetime-local"}
                          placeholder="dd-mm-yyyy"
                          value={values.endDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          touchedValue={touched.endDate}
                          errorsValue={errors.endDate}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="PageSize">
                        <Form.Label>Page Size*</Form.Label>
                        <SelectField
                          name={"PageSize"}
                          value={values.PageSize || ""}
                          onChange={(val) => setFieldValue("PageSize", val)}
                          listValue={pageSizeList}
                          isLoading={false}
                          placeholder={"Select Page Size"}
                          error={errors.PageSize}
                          setFieldError={() => {}}
                          touched={touched.PageSize}
                          setFieldTouched={() => {
                            setFieldTouched("PageSize", true);
                          }}
                          multiple={false}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="Orderby">
                        <Form.Label>Order By*</Form.Label>
                        <SelectField
                          name={"Orderby"}
                          value={values.Orderby || ""}
                          onChange={(val) => setFieldValue("Orderby", val)}
                          listValue={orderByList}
                          isLoading={false}
                          placeholder={"Order by"}
                          error={errors.Orderby}
                          setFieldError={() => {}}
                          touched={touched.Orderby}
                          setFieldTouched={() => {
                            setFieldTouched("Orderby", true);
                          }}
                          multiple={false}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Button
                        type="submit"
                        className={styles.btnSave}
                        disabled={allEarning.processing}
                      >
                        <div className={clsx(styles.btnContent)}>
                          {allEarning.processing ? (
                            <Spinner
                              animation="border"
                              role="status"
                              className="text-center"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          ) : null}
                          <span>Apply</span>
                        </div>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div className={clsx(styles.tableContainer)}>
            <div
              className={clsx(
                // "mt-4 rounded border overflow-hidden",
                styles.tableContent
              )}
            >
              {allEarning.data && !allEarning.processing ? (
                <TableSales dataList={allEarning.data} />
              ) : (
                <Spinner
                  animation="border"
                  role="status"
                  className="text-center"
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
            </div>
            <div className={clsx(styles.pagination)}>
              {allEarning.pagination ? (
                <Paginator data={allEarning.pagination} />
              ) : null}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
EarningPage.displayName = "EarningPage";

/* required: props types */
EarningPage.propTypes = {};

/* required: default props */
EarningPage.defaultProps = {};

export { EarningPage };
